export const DashboardAttendanceConstants = {
    //Trackings
    MONITORING_REFRESH: 'helpdesk-monitoring-refresh-button-clicked',
    MONITORING_ATTENDANT_STATUS_FILTERED: 'helpdesk-monitoring-agent-status-filtered',
    MONITORING_TICKET_SEARCHED: 'helpdesk-monitoring-ticket-searched',
    MONITORING_ATTENDANT_FILTERED: 'helpdesk-monitoring-agent-filtered',
    MONITORING_CONTACT_FILTERED: 'helpdesk-monitoring-contact-filtered',
    MONITORING_QUEUE_FILTERED: 'helpdesk-monitoring-general-queue-filtered',
    MONITORING_OPENED: 'helpdesk-monitoring-opened',
    MONITORING_TICKET_TRANSFERRED: 'desk-monitoring-ticket-transferred',
    MONITORING_FULLSCREEN_OPENED: 'helpdesk-monitoring-fullscreen-opened',
    MONITORING_DISCONNECT_AGENT: 'helpdesk-monitoring-sendalert-changestatusoffline',
    // Key LocalStorage
    ITEMS_PER_PAGE: 'helpdesk-monitoring-items-per-page',
    //filters
    DEFAULT_NUMBER_OF_AGENTS: 999,
};
